import { render, staticRenderFns } from "./DisplayList.vue?vue&type=template&id=0410e106"
import script from "./DisplayList.vue?vue&type=script&lang=js"
export * from "./DisplayList.vue?vue&type=script&lang=js"
import style0 from "./DisplayList.vue?vue&type=style&index=0&id=0410e106&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports